<template>
  <div class="employeeLimit">
    <div class="radio_box">
      <div class="title">角色选择：</div>

      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            v-for="(item,i) in list"
            shape="square"
            :key="i"
            :title="item.name"
            clickable
            @click="radio = item.id"
          >
            <template #right-icon>
              <van-radio :name="item.id" checked-color="#31B158"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <van-button type="primary" block color="#31B158" class="add_btn" @click="editLimit">保存</van-button>
    </div>
  </div>
</template>

<script>
import {
  employee_role_list,
  employee_role_edit,
  employee_role_info
} from "@/api/work/mine/employee";
export default {
  name: "employeeLimit",
  data() {
    return {
      list: [],
      radio: "",
      listQuery: { uid: "" }
    };
  },
  created() {
    this.listQuery.uid = this.$route.query.uid;
    this.getList();
  },
  mounted() {},
  methods: {
    editLimit(id) {
      let obj = {
        uid: this.listQuery.uid,
        role_id: this.radio
      };

      employee_role_edit(obj).then(res => {
        if (res.code == 200) {
          this.$toast.success(res.message);
          this.$router.go(-1);
        }
      });
    },
    getList() {
      employee_role_list().then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
      employee_role_info(this.listQuery).then(res => {
        if (res.code == 200) {
          this.radio = res.data.role_id + "";
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.employeeLimit {
  position: relative;
  .radio_box {
    background-color: #fff;
    box-sizing: border-box;
  }
  .title {
     padding: 0 0.3rem;
    box-sizing: border-box;
    padding-top: 0.2rem;
    line-height: 0.5rem;
    font-size: 0.36rem;
    font-weight: 600;
  }
  .radio_item {
    height: 0.92rem;
    padding-left: 0.3rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f5f5f5;
  }
  .add_btn {
    border-radius: 0.16rem;
    width: 6.9rem;
    margin: 0.3rem auto;
  }
}
</style>